import React from 'react';


const BarAnimation = () => {
    return (
        <div></div>
    )
}

export default BarAnimation